module.exports = __webpack_public_path__ + "static/media/deep.0838eaf8.jpeg";